import { ContentLink } from "@robe/client";
import { Box, Card, CardProps, Img, Typography } from "@xcorejs/ui";
import { useMemo } from "react";
import { resolveSrcSet } from "utils";
import { useLayout } from "xcore";
import { Event } from "xcore/types";

export type EventCardProps = {
  event: Pick<Event, "values" | "slug" | "type" | "id">;
} & CardProps;

const EventCard = ({ event }: EventCardProps) => {
  const { image, localize } = useLayout();

  const minimalGalleryVideosData = localize(event.values?.galleryVideos) ?? [];

  const thumbnail =
    minimalGalleryVideosData && minimalGalleryVideosData.length > 0
      ? minimalGalleryVideosData?.[0].values?.videoThumbnail
      : event.values.images?.[0];

  const thumbnailUrl = thumbnail ? image(thumbnail, { width: 280, height: 200 }) : null;

  const dateString = useMemo(() => {
    const date = new Date();
    date.setFullYear(parseInt(event.values.year!), parseInt(event.values.month!) - 1);
    return date.toLocaleDateString("fr-FR", {
      month: "long",
      year: "numeric",
    });
  }, [event.values]);

  if (!thumbnailUrl) {
    return null;
  }

  return (
    <ContentLink content={event}>
      <Card
        variant="outline"
        width="100%"
        cursor="pointer"
        body={
          <Box display="flex" flexDirection="column" justifyContent="space-around" width="100%" cursor="pointer">
            <Box cursor="pointer" width="100%" height="20rem">
              <Img
                src={thumbnailUrl}
                {...resolveSrcSet(thumbnailUrl, thumbnailUrl)}
                width="100%"
                height="100%"
                loading="lazy"
                objectFit="contain"
              />
            </Box>
            <Typography variant="h4" pl=".6rem" pt="1rem">
              {dateString}
            </Typography>
          </Box>
        }
        transition="box-shadow 300ms, border 300ms"
        boxShadow="0 3px 10px 0 rgba(30, 30, 30, 0.25)"
        _hover={{ boxShadow: "0 0.6rem 1.5rem 0 rgba(30, 30, 30, 0.5)" }}
        border={0}
        maxWidth="100%"
      />
    </ContentLink>
  );
};

export default EventCard;
